import dayjs, { Dayjs } from 'dayjs';
import { z } from 'zod';

export const dayjsSchema = z.custom<Dayjs>(
  (data) => dayjs.isDayjs(dayjs(data)),
  (input) => ({
    params: { expected: 'Dayjs', received: z.getParsedType(input) },
  }),
);
